export default __webpack_public_path__ + "static/msi-5af2984e7a54359c633ee8b869620ca0.png";